document.addEventListener('DOMContentLoaded', () => {
  const footer = document.querySelector('.pf-footer');

  if (!footer) return;

  const triggers = footer.querySelectorAll(
    '[data-pf-footer-accordion-trigger]'
  );

  const mobileBreakpoint = 749;

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (window.innerWidth > mobileBreakpoint) return;

      const item = trigger.closest('.pf-footer__accordion');
      const content = item?.querySelector(
        '[data-pf-footer-accordion-content]'
      );

      if (!item || !content) return;

      const isOpen = item.classList.contains('is-open');

      // Close all other accordion items
      footer
        .querySelectorAll('.pf-footer__accordion.is-open')
        .forEach((openItem) => {
          if (openItem !== item) {
            openItem.classList.remove('is-open');

            const openTrigger = openItem.querySelector(
              '[data-pf-footer-accordion-trigger]'
            );

            if (openTrigger) {
              openTrigger.setAttribute('aria-expanded', 'false');
            }
          }
        });

      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });
});

  // Poshak Tribe — open the existing Tribe popup
  const tribeTrigger = footer.querySelector('[data-pf-tribe-trigger]');

  if (tribeTrigger) {
    tribeTrigger.addEventListener('click', (event) => {
      const popup = document.getElementById('pf-tribe-overlay');

      // If the Tribe popup exists on this page,
      // let the popup system handle opening it.
      if (popup) {
        event.preventDefault();

        document.dispatchEvent(
          new CustomEvent('pf:open-tribe-popup')
        );
      }
    });
  }